import React from 'react';
import Icon from '../AppIcon';
import Image from '../AppImage';
import Button from './Button';

const PropertyContextHeader = ({ 
  property = null,
  actions = []
}) => {
  console.log('[PropertyContextHeader] ========== COMPONENT RENDER ==========');
  console.log('[PropertyContextHeader] Property:', property);
  console.log('[PropertyContextHeader] Actions count:', actions?.length);
  console.log('[PropertyContextHeader] Actions:', actions?.map(a => ({ label: a?.label, hasOnClick: !!a?.onClick, disabled: a?.disabled })));
  
  if (!property) {
    console.log('[PropertyContextHeader] No property provided, returning null');
    return null;
  }

  const {
    address = 'Property Address',
    owner = 'Owner Name',
    listingPrice = null,
    offerCount = 0,
    status = 'active',
    image = null,
    imageAlt = 'Property image'
  } = property;

  const statusConfig = {
    active: { label: 'Active', icon: 'CheckCircle', color: 'text-success' },
    pending: { label: 'Pending', icon: 'Clock', color: 'text-warning' },
    sold: { label: 'Sold', icon: 'Home', color: 'text-muted-foreground' },
    expired: { label: 'Expired', icon: 'XCircle', color: 'text-error' },
  };

  const currentStatus = statusConfig?.[status] || statusConfig?.active;

  const formatCurrency = (amount) => {
    if (!amount) return 'N/A';
    return new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'USD',
      minimumFractionDigits: 0,
      maximumFractionDigits: 0,
    })?.format(amount);
  };

  return (
    <div className="property-context-header" onClick={(e) => {
      console.log('[PropertyContextHeader] ========== HEADER CLICKED ==========');
      console.log('[PropertyContextHeader] Click target:', e?.target?.tagName, e?.target?.className);
      console.log('[PropertyContextHeader] Click currentTarget:', e?.currentTarget?.tagName);
    }}>
      <div className="property-context-container">
        <div className="property-context-content">
          {image && (
            <div className="flex-shrink-0">
              <Image
                src={image}
                alt={imageAlt}
                className="w-24 h-24 md:w-32 md:h-32 object-cover rounded-lg border border-border"
              />
            </div>
          )}
          
          <div className="property-context-info">
            <h2 className="property-context-address">{address}</h2>
            <div className="property-context-details">
              <div className="property-context-detail">
                <Icon name="User" size={16} />
                <span>{owner}</span>
              </div>
              
              {listingPrice && (
                <div className="property-context-detail">
                  <Icon name="DollarSign" size={16} />
                  <span>{formatCurrency(listingPrice)}</span>
                </div>
              )}
              
              <div className="property-context-detail">
                <Icon name="FileText" size={16} />
                <span>{offerCount} {offerCount === 1 ? 'Offer' : 'Offers'}</span>
              </div>
              
              <div className={`property-context-detail ${currentStatus?.color}`}>
                <Icon name={currentStatus?.icon} size={16} />
                <span>{currentStatus?.label}</span>
              </div>
            </div>
          </div>

          {actions?.length > 0 && (
            <div className="property-context-actions" onClick={(e) => {
              console.log('[PropertyContextHeader] ========== ACTIONS DIV CLICKED ==========');
              console.log('[PropertyContextHeader] Actions div click target:', e?.target?.tagName, e?.target?.className);
            }}>
              {actions?.map((action, index) => {
                console.log('[PropertyContextHeader] Rendering action button:', action?.label, 'disabled:', action?.disabled);
                return (
                  <Button
                    key={index}
                    variant={action?.variant || 'outline'}
                    size={action?.size || 'default'}
                    onClick={(e) => {
                      console.log('[PropertyContextHeader] ========== BUTTON WRAPPER CLICK ==========');
                      console.log('[PropertyContextHeader] Button label:', action?.label);
                      console.log('[PropertyContextHeader] Has onClick:', !!action?.onClick);
                      console.log('[PropertyContextHeader] Disabled:', action?.disabled);
                      if (action?.onClick) {
                        console.log('[PropertyContextHeader] Calling action.onClick...');
                        action?.onClick(e);
                        console.log('[PropertyContextHeader] action.onClick completed');
                      }
                    }}
                    iconName={action?.icon}
                    iconPosition={action?.iconPosition || 'left'}
                    disabled={action?.disabled}
                  >
                    {action?.label}
                  </Button>
                );
              })}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default PropertyContextHeader;